import React, { ReactElement } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import HomeDashboard from "../features/dashboard/Dashboard";
import LeadExplorer from "../features/leads/Leads";
import DashboardLayout from "../components/layout/Dashboard/DashboardLayout";
import ListsDashboard from "../features/lists/ListsDashboard";
import CompanyExplorer from "../features/company/CompanyExplorer";
import BulkUpload from "../features/bulk-upload/BullkUpload";
import Search from "../features/search/Search";
import Dashboard from "../features/dashboard/Dashboard";
import MyLists from "../features/lists/MyLists";
import APIAccess from "../features/api-access/APIAccess";
import UserProfile from "../features/user-profile/UserProfile";

function DashboardRoutes(): ReactElement {
  return (
    <BrowserRouter>
      <Routes>
        {/* The DashboardLayout wraps all internal routes to provide the Sidebar and Topbar */}
        <Route element={<DashboardLayout />}>
          {/* Matches the "Home" nav item */}
          <Route path="/" element={<Dashboard />} />
          <Route path="/search" element={<Search />} />
          <Route path="/bulk-upload" element={<BulkUpload />} />
          <Route path="/lists" element={<MyLists />} />
          <Route path="/api-access" element={<APIAccess />} />
          <Route path="/my-profile" element={<UserProfile />} />

          {/* You can add /companies, /lists, /analytics here later */}
        </Route>

        {/* Catch-all: redirects any unknown dashboard routes back to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default DashboardRoutes;
